import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import cn from 'classnames';
import { Link } from '@alfa-bank/site-link';

import type { TCommonLinkDesktop } from '../models';

import styles from './styles.css';

export const CommonLinkDesktop: FC<PropsWithChildren<TCommonLinkDesktop>> = ({
    DataLayer,
    analytics,
    children,
    className,
    dataTestId,
    link,
    title,
}) => {
    return (
        <DataLayer data={analytics}>
            <Link
                border="hidden"
                className={cn(styles.link, className)}
                dataTestId={dataTestId}
                href={link}
                title={title}
            >
                {children}
            </Link>
        </DataLayer>
    );
};
